export default "__VITE_ASSET__c691aacc__"